module.exports = __webpack_public_path__ + "img/phone_no_icon.f3bec140.svg";